import { CSSProperties } from "react";
import { IMG_BASE_URL, IMG_BASE_URL_NEXTJS } from "@vahak/core/dist/constants/misc";
import NextImage, { ImageLoader, ImageProps } from "next/image";

const myLoader: ImageLoader = ({ src, width, quality }) => {
    const isWebPNOTSupported = process.env.isWebPSupported === "0";
    return `${IMG_BASE_URL_NEXTJS}/${width}/${quality || 75}/${isWebPNOTSupported ? "default" : "webp"}/${src}`;
};

type LegacyLayout = "fill" | "fixed" | "intrinsic" | "responsive";

export type AppImgProps = Omit<ImageProps, "fill" | "width" | "height" | "alt"> & {
    layout?: LegacyLayout;
    objectFit?: CSSProperties["objectFit"];
    objectPosition?: CSSProperties["objectPosition"];
    fill?: boolean;
    alt?: string;
    width?: ImageProps["width"] | string;
    height?: ImageProps["height"] | string;
};

const AppImg = ({
    placeholder = "blur",
    layout,
    objectFit,
    objectPosition,
    style,
    fill,
    alt = "",
    width,
    height,
    ...props
}: AppImgProps) => {
    const isFill = fill || layout === "fill";
    const mappedStyle: CSSProperties | undefined = {
        ...style,
        ...(layout === "responsive" || layout === "intrinsic" ? { width: "100%", height: "auto" } : undefined),
        ...(objectFit ? { objectFit } : undefined),
        ...(objectPosition ? { objectPosition } : undefined)
    };
    const toDimension = (value: AppImgProps["width"]) => {
        if (typeof value === "string") {
            const parsed = Number.parseFloat(value);
            return Number.isNaN(parsed) ? undefined : parsed;
        }
        return value;
    };

    return (
        <NextImage
            loader={myLoader}
            placeholder={placeholder}
            alt={alt}
            width={toDimension(width)}
            height={toDimension(height)}
            blurDataURL={
                placeholder === "blur"
                    ? myLoader({
                          src: props.src as string,
                          width: 128,
                          quality: 1
                      })
                    : undefined
            }
            fill={isFill || undefined}
            style={mappedStyle}
            {...props}
            {...(props.unoptimized && {
                src: IMG_BASE_URL + props.src
            })}
        />
    );
};

export default AppImg;
